var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavIcon5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.58 0 0 3.58 0 8C0 11.54 2.29 14.53 5.47 15.59C5.87 15.66 6.02 15.42 6.02 15.22C6.02 15.03 6.01 14.39 6.01 13.7C4 14.19 3.48 13.37 3.32 12.92C3.23 12.7 2.78 11.95 2.49 11.76C2.19 11.57 1.84 11.15 2.5 11.17C3.17 11.19 3.61 11.88 3.78 12.11C4.5 13.14 5.68 12.82 6.05 12.62C6.12 12.11 6.33 11.77 6.56 11.57C4.75 11.37 2.87 10.66 2.87 7.58C2.87 6.76 3.16 6.08 3.73 5.59C3.65 5.39 3.41 4.57 3.84 3.44C3.84 3.44 4.49 3.22 6.02 4.33C6.65 4.14 7.35 4.04 8.02 4.04C8.69 4.04 9.39 4.14 10.02 4.33C11.54 3.22 12.18 3.44 12.18 3.44C12.61 4.57 12.37 5.39 12.29 5.59C12.85 6.08 13.13 6.76 13.13 7.58C13.13 10.67 11.24 11.37 9.42 11.57C9.75 11.77 10 12.12 10 12.67C10 13.27 10 14.03 10 15.22C10 15.42 10.15 15.66 10.55 15.59C13.71 14.53 16 11.53 16 8C16 3.58 12.42 0 8 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIcon5);
export default __webpack_public_path__ + "static/media/nav-icon5.7ee1d9fd967a3b0e683902b13e1fd614.svg";
export { ForwardRef as ReactComponent };